module.exports = __webpack_public_path__ + "img/illustration_staff_MR@2x.71f8f671.png";